// extracted by mini-css-extract-plugin
module.exports = {"form":"AddProfile_form__bUl6z","spacing":"AddProfile_spacing__lR07N","widthHalfPage":"AddProfile_widthHalfPage__CP3WW"};